import { render, staticRenderFns } from "./ExtratoUtilizacaoUnimed.vue?vue&type=template&id=33a11bfa&scoped=true&"
import script from "./ExtratoUtilizacaoUnimed.vue?vue&type=script&lang=js&"
export * from "./ExtratoUtilizacaoUnimed.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoUtilizacaoUnimed.vue?vue&type=style&index=0&id=33a11bfa&lang=scss&scoped=true&"
import style1 from "./ExtratoUtilizacaoUnimed.vue?vue&type=style&index=1&id=33a11bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a11bfa",
  null
  
)

export default component.exports